import * as React from 'react'
import { customerMarketShopfrontApi, Site } from '@envato/foundation-types'
import Button, { ButtonAppearance, ButtonSize } from '@envato/foundation-button'

import { getConfigBySite } from '../../../../config/sites'
import { reportCategoryPageClick } from '../../../../common/analytics/categoryPageAnalytics'
import { IBlockMatchedComponent } from '../../../pages/category/category'
import ItemCardsLayout from '../../itemCardsLayout'
import ImagePlaceholder from '../../imagePlaceholder'
import ImagePreview from '../../imagePreview'
import { addUTMParamsToURL, IPromoData } from './elementsPromoItemsBlock'

import * as styles from './originalElementsPromoItemsBlock.module.css'

interface IProps extends IBlockMatchedComponent {
  data: IPromoData[]
  title: string
  cta: customerMarketShopfrontApi.categoryPage.ICta
}

const promoItem = (item: IPromoData, currentSite: Site) => {
  const { author, title, itemURL, previews } = item
  const urlWithParams = addUTMParamsToURL(itemURL, currentSite)
  const alt = `${title} by ${author}`
  const ratio = getConfigBySite(currentSite, 'ui.image_preview_ratio')

  return (
    <div className={styles.itemWrapper}>
      <a
        className={styles.itemImageWrapper}
        href={urlWithParams}
        target="_blank"
        rel="noopener noreferrer"
      >
        <ImagePlaceholder ratio={ratio}>
          {previews && (
            <ImagePreview
              className={styles.itemImage}
              previews={previews}
              alt={alt}
            />
          )}
        </ImagePlaceholder>
      </a>
      <a
        className={styles.itemDescription}
        href={urlWithParams}
        target="_blank"
        rel="noopener noreferrer"
      >
        <span className={styles.itemTitle}>{title}</span> by{' '}
        <span
          className={styles.itemAuthor}
          onClick={reportCategoryPageClick(`authorlink_${author}`)}
        >
          {author}
        </span>
      </a>
    </div>
  )
}

const OriginalElementsPromoItemsBlock = ({
  title,
  subtitle,
  cta,
  data,
  currentSite
}: IProps) => (
  <section className={styles.root}>
    <div className={styles.promoItemsBlockWrapper}>
      <ItemCardsLayout viewType="grid">
        <ItemCardsLayout.CardArea className={styles.promoItem}>
          <div className={styles.campaignTextWrapper}>
            <header>
              <h2 className={styles.title}>{title}</h2>
              {subtitle && <h3 className={styles.subtitle}>{subtitle}</h3>}
            </header>
            <Button
              className={styles.button}
              appearance={ButtonAppearance.Primary}
              size={ButtonSize.Small}
              href={addUTMParamsToURL(cta.url, currentSite)}
              onClick={reportCategoryPageClick('traffic to elements')}
              target="_blank"
              rel="noopener noreferrer"
            >
              {cta.title}
            </Button>
          </div>
        </ItemCardsLayout.CardArea>
        {data.map((item: IPromoData, index: number) => (
          <ItemCardsLayout.CardArea key={index}>
            {promoItem(item, currentSite)}
          </ItemCardsLayout.CardArea>
        ))}
      </ItemCardsLayout>
    </div>
  </section>
)

export default OriginalElementsPromoItemsBlock
